<script setup>
import { getCurrentInstance, onMounted, ref, watch, } from 'vue'
import { getActivePinia, storeToRefs, } from 'pinia'
import LoadingDummyCustom from '@/assets/js/src/components/loading/LoadingDummyCustom'
import cookieManager from '@/assets/js/src/util/cookieManagerWrapper'
import { useConsentStore, } from '@/assets/js/src/modules/imprint/_pinia/consent'
import { useTranslation,useMessagesLoaded, } from '@/assets/js/src/util/composables'

const COOKIE = 'bs-matomo-opt-out'
const matomoHint = ref(false)
const matomoOptOut = ref(true)
const { proxy, } = getCurrentInstance()
const { messagesLoaded, } = useMessagesLoaded([ 'imprint', ])
const { t, } = useTranslation()

const { consent, } = storeToRefs(useConsentStore(getActivePinia()))
watch(consent, (newValue) => {
    if (typeof newValue?.statistics !== 'undefined') {
        matomoHint.value = !newValue.statistics
    }
})

onMounted(() => {
    const interval = setInterval(() => {
        if (window.Cookiebot?.consent) {
            clearInterval(interval)
            if (window.Cookiebot.consent.statistics === false) {
                matomoHint.value = true
                matomoOptOut.value = !cookieManager.get(COOKIE)
            }
        }
    }, 100)
})

const openCookieSettings = function (ev) {
    ev.preventDefault()
    !window.ccSettingsDialog && window.Cookiebot && window.Cookiebot.renew()
    const interval = setInterval(() => {
        if (window.ccSettingsDialog) {
            clearInterval(interval)
            window.ccSettingsDialog(ev, true)
        }
    }, 25)
}
const handleOption = function (ev) {
    ev.preventDefault()
    if (matomoOptOut.value && window.Cookiebot && !window.Cookiebot.consent.statistics) {
        proxy.$matomo && proxy.$matomo.optUserOut()
        matomoOptOut.value = false
        cookieManager.set(COOKIE, 'true', { expires: 3650, })
    } else {
        proxy.$matomo && proxy.$matomo.forgetUserOptOut()
        matomoOptOut.value = true
        cookieManager.remove(COOKIE)
        cookieManager.remove('mtm_consent_removed')
    }
}
</script>

<template>
    <div
        v-if="messagesLoaded"
        class="imprint__cc-icon"
    >
        <p>
            <strong>
                {{ t('async.imprint.cookie.heading') }}
            </strong>
        </p>
        <p v-html="t('async.imprint.cookie.text')"></p>
        <p>
            <v-btn
                class="bg-secondary"
                @click.stop.prevent="openCookieSettings($event)"
            >
                <div class="v-icon"></div>
                {{ t('async.imprint.cookie.settings-btn') }}
            </v-btn>
        </p>
        <section v-if="matomoHint">
            <p>{{ t('async.imprint.cookie.matomo.text') }}</p>
            <p>
                <v-btn
                    class="bg-secondary"
                    @click.stop.prevent="handleOption($event)"
                >
                    {{ t(`async.imprint.cookie.matomo.btn_opt-${matomoOptOut ? 'out' : 'in'}`) }}
                </v-btn>
            </p>
        </section>
    </div>
    <loading-dummy-custom
        v-else
        height="18px"
        width="300px"
    ></loading-dummy-custom>
</template>

<style lang="scss">
.bs-app .imprint__cc-icon {
    .v-icon {
        display: block;
        width: 1.6em;
        height: 1.4em;
        background: url("data:image/svg+xml;base64,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");
        background-repeat: no-repeat;
    }
}
</style>
